import _slicedToArray from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
var TagsView = /*#__PURE__*/function (_VuexModule) {
  function TagsView() {
    var _this;
    _classCallCheck(this, TagsView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TagsView, [].concat(args));
    _defineProperty(_this, "visitedViews", []);
    _defineProperty(_this, "cachedViews", []);
    return _this;
  }
  _inherits(TagsView, _VuexModule);
  return _createClass(TagsView, [{
    key: "ADD_VISITED_VIEW",
    value: function ADD_VISITED_VIEW(view) {
      if (this.visitedViews.some(function (v) {
        return v.path === view.path;
      })) return;
      this.visitedViews.push(Object.assign({}, view, {
        title: view.meta.title || 'no-name'
      }));
    }
  }, {
    key: "ADD_CACHED_VIEW",
    value: function ADD_CACHED_VIEW(view) {
      if (this.cachedViews.includes(view.name)) return;
      if (!view.meta.noCache) {
        this.cachedViews.push(view.name);
      }
    }
  }, {
    key: "DEL_VISITED_VIEW",
    value: function DEL_VISITED_VIEW(view) {
      var _iterator = _createForOfIteratorHelper(this.visitedViews.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            i = _step$value[0],
            v = _step$value[1];
          if (v.path === view.path) {
            this.visitedViews.splice(i, 1);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "DEL_CACHED_VIEW",
    value: function DEL_CACHED_VIEW(view) {
      var _iterator2 = _createForOfIteratorHelper(this.cachedViews.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            i = _step2$value[0],
            v = _step2$value[1];
          if (v === view.name) {
            this.cachedViews.splice(i, 1);
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "DEL_OTHERS_VISITED_VIEWS",
    value: function DEL_OTHERS_VISITED_VIEWS(view) {
      this.visitedViews = this.visitedViews.filter(function (v) {
        return v.meta.affix || v.path === view.path;
      });
    }
  }, {
    key: "DEL_OTHERS_CACHED_VIEWS",
    value: function DEL_OTHERS_CACHED_VIEWS(view) {
      var _iterator3 = _createForOfIteratorHelper(this.cachedViews.entries()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            i = _step3$value[0],
            v = _step3$value[1];
          if (v === view.name) {
            this.cachedViews = this.cachedViews.slice(i, i + 1);
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "DEL_ALL_VISITED_VIEWS",
    value: function DEL_ALL_VISITED_VIEWS() {
      // keep affix tags
      var affixTags = this.visitedViews.filter(function (tag) {
        return tag.meta.affix;
      });
      this.visitedViews = affixTags;
    }
  }, {
    key: "DEL_ALL_CACHED_VIEWS",
    value: function DEL_ALL_CACHED_VIEWS() {
      this.cachedViews = [];
    }
  }, {
    key: "UPDATE_VISITED_VIEW",
    value: function UPDATE_VISITED_VIEW(view) {
      var _iterator4 = _createForOfIteratorHelper(this.visitedViews),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var v = _step4.value;
          if (v.path === view.path) {
            v = Object.assign(v, view);
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "addView",
    value: function addView(view) {
      this.ADD_VISITED_VIEW(view);
      this.ADD_CACHED_VIEW(view);
    }
  }, {
    key: "addVisitedView",
    value: function addVisitedView(view) {
      this.ADD_VISITED_VIEW(view);
    }
  }, {
    key: "delView",
    value: function delView(view) {
      this.DEL_VISITED_VIEW(view);
      this.DEL_CACHED_VIEW(view);
    }
  }, {
    key: "delCachedView",
    value: function delCachedView(view) {
      this.DEL_CACHED_VIEW(view);
    }
  }, {
    key: "delOthersViews",
    value: function delOthersViews(view) {
      this.DEL_OTHERS_VISITED_VIEWS(view);
      this.DEL_OTHERS_CACHED_VIEWS(view);
    }
  }, {
    key: "delAllViews",
    value: function delAllViews() {
      this.DEL_ALL_VISITED_VIEWS();
      this.DEL_ALL_CACHED_VIEWS();
    }
  }, {
    key: "delAllCachedViews",
    value: function delAllCachedViews() {
      this.DEL_ALL_CACHED_VIEWS();
    }
  }, {
    key: "updateVisitedView",
    value: function updateVisitedView(view) {
      this.UPDATE_VISITED_VIEW(view);
    }
  }]);
}(VuexModule);
__decorate([Mutation], TagsView.prototype, "ADD_VISITED_VIEW", null);
__decorate([Mutation], TagsView.prototype, "ADD_CACHED_VIEW", null);
__decorate([Mutation], TagsView.prototype, "DEL_VISITED_VIEW", null);
__decorate([Mutation], TagsView.prototype, "DEL_CACHED_VIEW", null);
__decorate([Mutation], TagsView.prototype, "DEL_OTHERS_VISITED_VIEWS", null);
__decorate([Mutation], TagsView.prototype, "DEL_OTHERS_CACHED_VIEWS", null);
__decorate([Mutation], TagsView.prototype, "DEL_ALL_VISITED_VIEWS", null);
__decorate([Mutation], TagsView.prototype, "DEL_ALL_CACHED_VIEWS", null);
__decorate([Mutation], TagsView.prototype, "UPDATE_VISITED_VIEW", null);
__decorate([Action], TagsView.prototype, "addView", null);
__decorate([Action], TagsView.prototype, "addVisitedView", null);
__decorate([Action], TagsView.prototype, "delView", null);
__decorate([Action], TagsView.prototype, "delCachedView", null);
__decorate([Action], TagsView.prototype, "delOthersViews", null);
__decorate([Action], TagsView.prototype, "delAllViews", null);
__decorate([Action], TagsView.prototype, "delAllCachedViews", null);
__decorate([Action], TagsView.prototype, "updateVisitedView", null);
TagsView = __decorate([Module({
  dynamic: true,
  store: store,
  name: 'tagsView'
})], TagsView);
export var TagsViewModule = getModule(TagsView);